import React from 'react';
import styled from 'styled-components';
import useI18n from '../../../i18n';
import TextField from '../../../Components/TextField';
import { TContactData } from '../../../Hooks/useCustomerData';

const Wrapper = styled.div`
  padding: 14px 24px;
  background-color: #fff;
`;

const Title = styled.h2`
  font-size: 16px;
  letter-spacing: 0.24px;
  line-height: 24px;
  margin: 0 0 16px 0;
`;

interface Props {
  /**
   * contactData
   */
  contactData: TContactData;
  /**
   * onChangeContactData
   */
  onChangeContactData: (event: React.ChangeEvent<any>) => void;
}

/**
 * ContactDataForm component
 */

const ContactDataForm: React.FC<Props> = ({ contactData, onChangeContactData }: Props) => {
  const { i18n } = useI18n();

  return (
    <Wrapper>
      <Title>{i18n('Cart.ContactData.Title')}:</Title>
      <TextField
        label={i18n('Signup.Name')}
        placeholder={i18n('Signup.Name.Placeholder')}
        onChange={onChangeContactData}
        value={contactData.name}
        name={'name'}
        error={contactData.errors.name}
      />
      <TextField
        label={i18n('Input.Phone')}
        placeholder={i18n('Signup.Phone.Placeholder')}
        onChange={onChangeContactData}
        value={contactData.phone}
        name={'phone'}
        error={contactData.errors.phone}
        type={'tel'}
      />
    </Wrapper>
  );
};

export default ContactDataForm;
